<script>
  export let onClick
  export let color = "#184398";
</script>

<button on:click={onClick}>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="14" width="14" height="2" rx="1" fill="#00468F" transform="scale(1.5)"/>
    <path
      transform="scale(1.5)"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.7831 1.39705C11.1737 1.00652 11.8068 1.00652 12.1973 1.39705L13.6116 2.81126C14.0021 3.20179 14.0021 3.83495 13.6116 4.22548L11.4903 6.34674L11.4905 6.34698L5.83368 12.0038H3.00526L3.00526 9.17541L8.64329 3.53738C8.64936 3.53098 8.65553 3.52464 8.66181 3.51837L10.7831 1.39705ZM12.9044 3.51808L11.4902 2.10387L10.076 3.51808L11.4902 4.93229L12.9044 3.51808Z"
      fill="{color}"
    />
  </svg>
</button>

<style>
  svg {
    vertical-align: middle;
  }
</style>
